import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { ConnectFlowModel, Permission } from '@/types';
import { applyPhoneMask } from '@/utils/number';
import { PhoneIcon } from '@heroicons/vue/solid';
import ConnectFlowIcon from '@/components/svg/ConnectFlowIcon';
import { ArchiveIcon, CheckCircleIcon, PencilAltIcon, XCircleIcon } from '@heroicons/vue/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowListItem',
  props: {
    modelValue: {
        type: Object as PropType<ConnectFlowModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const handleActivateClick = () => emit('activate', props.modelValue);
const handleInactivateClick = () => emit('inactivate', props.modelValue);

const __returned__ = { props, emit, handleActivateClick, handleInactivateClick, get Permission() { return Permission }, get applyPhoneMask() { return applyPhoneMask }, get PhoneIcon() { return PhoneIcon }, get ConnectFlowIcon() { return ConnectFlowIcon }, get ArchiveIcon() { return ArchiveIcon }, get CheckCircleIcon() { return CheckCircleIcon }, get PencilAltIcon() { return PencilAltIcon }, get XCircleIcon() { return XCircleIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})